import {
  ComponentItemConfig,
  LayoutConfig,
  ResolvedLayoutConfig,
  RootItemConfig,
} from 'golden-layout'
import { cloneDeep } from 'lodash-es'

/**
 * Find all components in the layout
 *
 * @returns array of components
 */
function flattenConfigItems(items?: RootItemConfig) {
  const components: ComponentItemConfig[] = []

  items?.content?.forEach(item => {
    if (Array.isArray(item.content) && item.content.length > 0) {
      components.push(...flattenConfigItems(item))
    } else {
      if (item.type === 'component') {
        components.push(item)
      }
    }
  })

  return components
}

/**
 * Get all the panel components that are in the layout
 */
export function getAllPanels(layout: LayoutConfig) {
  return flattenConfigItems(layout.root)
}

/**
 * Check if the layout is currently in a locked state.
 * It will be locked if ANY of the panels are locked.
 */
export function isLayoutLocked(layout: ResolvedLayoutConfig) {
  const configs = flattenConfigItems(layout.root as unknown as RootItemConfig)
  return configs.some(x => x.reorderEnabled === false)
}

/**
 * Changes a layout configuration to be a either a locked or unlocked configuration.
 */
export function createLockedLayout(
  layout: ResolvedLayoutConfig,
  lock: boolean,
) {
  let pureLayout = cloneDeep(layout)
  pureLayout = {
    ...pureLayout,
    settings: {
      ...pureLayout.settings,
      reorderEnabled: !lock,
    },
  }

  const configs = flattenConfigItems(
    pureLayout.root as unknown as RootItemConfig,
  )
  configs.forEach(config => {
    config.reorderEnabled = !lock
    config.isClosable = !lock
  })

  return pureLayout as unknown as LayoutConfig
}
